import React, {useState} from 'react';
import {useAppSelector} from "../../creator-presets/DAL/store";
import Preset from "../../common/components/preset";
import {PresetDM, PresetTagDM} from "../../common/interfaces";
import {isMobile} from "../../../../domain/common";
import {Popup} from "../../../../ui/popup/popup";
import RightArrowIcon from "../../common/svg/right-arrow";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

const MorePresets = () => {
    const [showLinkCopiedPopup, setShowLinkCopiedPopup] = useState(false);

    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const mainPreset = useAppSelector((store) => store.mainPreset);
    const otherPresets = (PresetPageData.presets as PresetDM[]).filter(preset => preset.presetID !== mainPreset.presetID);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);
    const isMobileScreen = isMobile();

    return (
        <div className="w-full mt-10">
            <div className="w-full font-bold flex justify-between">
                <div className="font-bold text-2xl">More from {PresetPageData.profile.publicName}</div>
                {!isMobileScreen && otherPresets.length >= 4 && <a className="text-black flex items-center"
                                       onClick={(evt) => {
                                           sendGAEvent('Click', "View All Chains: " + PresetPageData.profile.handle);
                                       }}
                                       href={"/studioverse/creator/chains/" + PresetPageData.profile.handle.toLowerCase() }>
                                        <span className="pr-2 font-medium">View All Chains</span>
                                        <RightArrowIcon width={"7px"} color="black"/>
                                    </a>}
            </div>
            <div className="w-full mt-4">
                <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {otherPresets.map((preset,index) => {
                        const presetTags = (PresetPageData.presetTags as PresetTagDM[]).filter(tag => tag.presetID === preset.presetID);
                        return <li className="grid-item" key={preset.presetID + "_" + index}>
                            <Preset preset={preset} profile={PresetPageData.profile} isHandleLinked={true} presetTags={presetTags} imgCdnDomain={imgCdnDomain} creatorsPath={creatorsPath} setShowLinkCopiedPopup={setShowLinkCopiedPopup} />
                        </li>
                    })}
                </ul>
            </div>
            {otherPresets.length >= 4 &&
                <div className="w-full flex items-center justify-center my-12 md:my-16">
                    <a className="w-btn py-3 px-8 w-auto font-normal flex items-center"
                       href={"/studioverse/creator/chains/" + PresetPageData.profile.handle.toLowerCase()}
                       onClick={(evt) => {
                           sendGAEvent('Click', "View All Chains: " + PresetPageData.profile.publicName);
                       }}
                        >
                        <span className="pr-2 font-normal">View All {PresetPageData.profile.publicName}'s Chains</span>
                        <RightArrowIcon width={"8px"} color="white"/>
                    </a>
                </div>
            }
            {showLinkCopiedPopup && <Popup classes="py-10" close={() => setShowLinkCopiedPopup(false)}>
                <div className="ok-box" role="alert">The link was copied to clipboard</div>
            </Popup>}
        </div>

    )
};

export default MorePresets;